import React from 'react';
import classNames from 'classnames';
import { compose, onlyUpdateForKeys } from 'recompose';
import withCollapsible, { withCollapsibleDefs } from 'components/hoc/withCollapsible/withCollapsible';
import Button from 'components/general/Button/Button';
import Icon from 'components/general/Icon/Icon';

const FilterList: React.SFC<FilterListPropDef & withCollapsibleDefs> = ({
  headerSlot,
  actionBarSlot,
  filterSlot,
  listSlot,
  paginationSlot,
  isOpen,
  onToggle,
  onClose,
}) => (
  <div
    className={classNames('l-list-page', {
      'l-list-page--filters-open': isOpen,
    })}
  >
    <div className="l-list-page__header">
      {headerSlot}
    </div>
    <div className="l-list-page__action-bar" onClick={onClose}>
      {actionBarSlot}
    </div>
    {filterSlot && (
      <Button
        onClick={onToggle}
        className="l-list-page__toggle"
        types={['box', 'ta-left', ...(isOpen ? ['accent'] : [])]}
      >
        <Icon name="filter" types={['push-right']} />
        {isOpen ? 'Close' : 'View'} filters
      </Button>
    )}
    <div className="l-list-page__main">
      <div className="l-list-page__filters">
        {filterSlot}
      </div>
      <div className="l-list-page__list">
        {listSlot}
      </div>
      <div className="l-list-page__pagination">
        {paginationSlot}
      </div>
    </div>
  </div>
);

interface FilterListPropDef {
  headerSlot?: JSX.Element;
  actionBarSlot?: JSX.Element;
  filterSlot?: JSX.Element;
  listSlot?: JSX.Element;
  paginationSlot?: JSX.Element;
}

const FilterListComposed: React.SFC<FilterListPropDef> = compose(
  onlyUpdateForKeys([]),
  withCollapsible(),
)(FilterList);

export default FilterListComposed;

